import { Form, Input } from 'antd';
import { FormInstance } from 'antd/es/form';
import { useTranslation } from 'react-i18next';

import type { SectionFormValues } from '../../types';

import { FormItemDescription } from './SectionForm.styles';

import { RULES } from '@/constants';

type SectionFormProps = {
  form: FormInstance<SectionFormValues>;
  onFinish: () => void;
  hideDescription?: boolean;
};

const MAX_LENGTH = 750;

export const SectionForm: React.FC<SectionFormProps> = ({ form, onFinish, hideDescription }) => {
  const { t } = useTranslation('ManagerBaseContentDetailTranslations');

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Form.Item label={t('NAME_LABEL')} name="name" rules={[RULES.REQUIRED]}>
        <Input placeholder={t('NAME_PLACEHOLDER')} />
      </Form.Item>
      {!hideDescription && (
        <FormItemDescription name="description" label={t('DESCRIPTION_LABEL')}>
          <Input.TextArea
            rows={4}
            autoSize={{ minRows: 4, maxRows: 10 }}
            maxLength={MAX_LENGTH}
            showCount
            placeholder={t('DESCRIPTION_PLACEHOLDER')}
          />
        </FormItemDescription>
      )}
    </Form>
  );
};
